// extracted by mini-css-extract-plugin
export var bodySections = "_b8-8";
export var gray = "_b8-7";
export var green = "_b8-4";
export var iconContainer = "_b8-9";
export var iconWidgetContainer = "_b8-1";
export var phoneIcon = "_b8-2";
export var red = "_b8-5";
export var statusDot = "_b8-3";
export var widgetContainer = "_b8-0";
export var yellow = "_b8-6";